<template lang="pug">
  .b-spec-new-row(data-testid="spec-new-row")
    ._bar
      input._name(
        ref="name"
        data-testid="spec-new-row-name"
        v-model="name"
        placeholder="Наименование"
        @keydown.enter="save"
        )
      select._category(data-testid="spec-new-row-category" v-model="category")
        option(value="" data-testid="spec-new-row-category-option") — категория —
        option(v-for="(title, code) in CATEGORIES" :key="code" :value="code" data-testid="spec-new-row-category-option") {{ title }}
      Btn(blue xs data-testid="spec-new-row-save" @click="save") Сохранить
      Btn(grey xs data-testid="spec-new-row-cancel" @click="$emit('cancel')") Отмена
</template>

<script>
import { CATEGORIES } from '@/utils/spec';

/**
 * Строка новой позиции (ТЗ 6.2): в группе-категории категория подставлена, в группе-помещении и
 * в пустой спецификации выбирается здесь. До выбора категории и наименования строка существует
 * только на экране — на сервер она уходит по «Сохранить».
 *
 * Содержимое прижато к левому краю: строка живёт внутри таблицы с горизонтальной прокруткой.
 * Сгенерировано Claude.
 */
export default {
  name: 'SpecNewRow',
  props: {
    /** Подставленная категория (в группе-категории) или пусто. */
    defaultCategory: { type: String, default: '' },
    /** Подставленное помещение (в группе-помещении) или null. */
    room: { type: String, default: null },
  },
  data() {
    return {
      CATEGORIES,
      name: '',
      category: this.defaultCategory ?? '',
    };
  },
  mounted() {
    const { name } = this.$refs;
    if (name) name.focus();
  },
  methods: {
    save() {
      if (!this.name.trim() || !this.category) return;
      this.$emit('save', { name: this.name.trim(), category: this.category, room: this.room });
    },
  },
};
</script>

<style scoped lang="scss">
.spec-new-row {
  background: #FFFDF2;
  border-bottom: 1px solid var(--color-super-light);

  &__bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    width: max-content;
    // строка живёт внутри таблицы шириной в несколько экранов: прилипание к левому краю
    // области прокрутки держит поля на виду при любом смещении вправо
    position: sticky;
    left: 0;
  }

  &__name,
  &__category {
    box-sizing: border-box;
    padding: 5px 8px;
    border: 1px solid var(--color-super-light);
    border-radius: 6px;
    font: inherit;
    font-size: 12px;
  }

  &__name {
    width: 260px;
  }
}
</style>
